import axios from "axios";
import {
  EMP_REQUEST,
  EMP_SUCCESS,
  EMP_FAIL,
  EMP_CLEAR_ERRORS,
  UPDATE_EMP_CLEAR_ERRORS,
  UPDATE_EMP_FAIL,
  UPDATE_EMP_REQUEST,
  UPDATE_EMP_SUCCESS,
  EMP_IMPORT_REQUEST,
  EMP_IMPORT_SUCCESS,
  EMP_IMPORT_FAIL,
  EMP_IMPORT_CLEAR_ERRORS,
  EMP_SEARCH_REQUEST,
  EMP_SEARCH_SUCCESS,
  EMP_SEARCH_FAIL,
  EMP_SEARCH_CLEAR_ERRORS,
  EMP_BY_REQUEST,
  EMP_BY_SUCCESS,
  EMP_BY_FAIL,
  EMP_BY_CLEAR_ERRORS,
  EMP_BY_ID_REQUEST,
  EMP_BY_ID_SUCCESS,
  EMP_BY_ID_FAIL,
  EMP_BY_ID_CLEAR_ERRORS,
  LOCK_REQUEST, LOCK_SUCCESS, LOCK_FAIL, LOCK_CLEAR_ERRORS
} from "../Constants/employees_constants";
import { user_errors } from "../ErrorsHandler";

export const get_employees = (company) => async (dispatch) => {
  try {
    dispatch({
      type: EMP_REQUEST,
    });
    const employees = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/user-get/?`,
      {
        params: { company_name: company === null ? "" : company },
      }
    );
    dispatch({
      type: EMP_SUCCESS,
      payload: employees,
    });
  } catch (error) {
    dispatch({
      type: EMP_FAIL,
      payload: error.response,
    });
  }
};

export const update_employee = (update_payload, id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_EMP_REQUEST,
    });

    const update_empl = await axios.patch(
      `${process.env.REACT_APP_API_URL}/api/employee-registration/`,
      update_payload
    );

    dispatch({
      type: UPDATE_EMP_SUCCESS,
      payload: update_empl,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EMP_FAIL,
      payload: user_errors(error.response.data),
    });
  }
};

export const employees_clearErrors = () => async (dispatch) => {
  dispatch({
    type: EMP_CLEAR_ERRORS,
  });
};

export const update_emp_clearErrors = () => async (dispatch) => {
  dispatch({
    type: UPDATE_EMP_CLEAR_ERRORS,
  });
};

export const delete_employee = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_EMP_REQUEST,
    });
    await axios.delete(`${process.env.REACT_APP_API_URL}/api/users/${id}/`);
    const user_data = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/auth-user/`
    );
    dispatch({
      type: UPDATE_EMP_SUCCESS,
      payload: user_data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EMP_FAIL,
      payload: error.response,
    });
  }
};

export const bulk_add_emp = (bulk_payload) => async (dispatch) => {
  var formData = new FormData();
  formData.append("file", bulk_payload);
  try {
    dispatch({
      type: EMP_IMPORT_REQUEST,
    });
    const newdata = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/user-import/`,
      formData
    );
    console.log(newdata);
    dispatch({
      type: EMP_IMPORT_SUCCESS,
      payload: newdata,
    });
  } catch (error) {
    dispatch({
      type: EMP_IMPORT_FAIL,
      payload: error.response,
    });
  }
};

export const bulk_emp_clearErrors = () => async (dispatch) => {
  dispatch({
    type: EMP_IMPORT_CLEAR_ERRORS,
  });
};

export const get_search_employees = (emp_name) => async (dispatch) => {
  try {
    dispatch({
      type: EMP_SEARCH_REQUEST,
    });
    const employees = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/users/?`,
      {
        params: { search: emp_name === null ? "" : emp_name },
      }
    );
    dispatch({
      type: EMP_SEARCH_SUCCESS,
      payload: employees.data,
    });
  } catch (error) {
    dispatch({
      type: EMP_SEARCH_FAIL,
      payload: error.response,
    });
  }
};

export const search_employees_clearErrors = () => async (dispatch) => {
  dispatch({
    type: EMP_SEARCH_CLEAR_ERRORS,
  });
};

export const get_search_employees_by = (type, val) => async (dispatch) => {
  try {
    dispatch({
      type: EMP_BY_REQUEST,
    });
    switch (type) {
      case "designation":
        const employees_by_des = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/search_des_grp/?`,
          {
            params: { designation: val },
          }
        );
        dispatch({
          type: EMP_BY_SUCCESS,
          payload: employees_by_des.data,
        });
        break;
      case "department":
        const employees_by_dep = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/search_des_grp/?`,
          {
            params: { department: val },
          }
        );
        dispatch({
          type: EMP_BY_SUCCESS,
          payload: employees_by_dep.data,
        });
        break;
      default:
        console.error("employee actions case not found");
        break;
    }
  } catch (error) {
    dispatch({
      type: EMP_BY_FAIL,
      payload: error.response,
    });
  }
};

export const search_employees_by_clearErrors = () => async (dispatch) => {
  dispatch({
    type: EMP_BY_CLEAR_ERRORS,
  });
};


export const get_search_employees_by_id = (val) => async (dispatch) => {
  try {
    dispatch({
      type: EMP_BY_ID_REQUEST,
    });
    const employees_by_id = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/employee/${val}/`
    );
    dispatch({
      type: EMP_BY_ID_SUCCESS,
      payload: employees_by_id.data,
    });
  } catch (error) {
    dispatch({
      type: EMP_BY_ID_FAIL,
      payload: error.response,
    });
  }
};

export const search_employees_by_id_clearErrors = () => async (dispatch) => {
  dispatch({
    type: EMP_BY_ID_CLEAR_ERRORS,
  });
};


export const lock_work_location = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: LOCK_REQUEST,
    });
    const lock = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/workforce-approval/`, payload
    );
    dispatch({
      type: LOCK_SUCCESS,
      payload: lock.data,
    });
  } catch (error) {
    dispatch({
      type: LOCK_FAIL,
      payload: error.response,
    });
  }
};

export const lock_work_location_clearErrors = () => async (dispatch) => {
  dispatch({
    type: LOCK_CLEAR_ERRORS,
  });
};